import { ColumnOrder } from '../../../api/globalTypes'
import { sortingToOrder } from '../utils/utils'
import useTableSettings, { DEFAULT_COLUMN_SORT } from './useTableSettings'

/**
 * Resolves a table's persisted sort into the API `order` param shape, falling back to the
 * same per-table default the table itself uses (see DEFAULT_COLUMN_SORT) when nothing is stored yet.
 *
 * @param tableKey - table settings key (e.g. 'property', 'project', 'contact', 'company')
 */
const useColumnOrder = (tableKey: string): ColumnOrder | undefined => {
    const { storedSort } = useTableSettings(tableKey)
    const sorting = storedSort ?? DEFAULT_COLUMN_SORT[tableKey] ?? DEFAULT_COLUMN_SORT.default

    return sortingToOrder(sorting)
}

export default useColumnOrder
